import { Injectable } from '@angular/core';
import { FileType } from '@fi-shared/types';
import { isDefined } from '@fi-shared/utils/is-defined';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

const FileSilentUploadLimit = 5; // mb

@Injectable()
export class FileTypeService {
    constructor(private customerDataService: FiCustomerDataService) {}

    getFileType(file: File): FileType {
        const knownExtension = this.getKnownFileExtension(file);
        if (knownExtension) {
            return this.customerDataService.customerData.FileTypeExtensions[knownExtension] || FileType.Unknown;
        }
        return FileType.Unknown;
    }

    getFileExtension(fileName: string) {
        const extensionMatch = fileName.match(/^.+(\..+)$/i);
        return extensionMatch && isDefined(extensionMatch[1]) ? extensionMatch[1].toUpperCase() : '';
    }

    private getKnownFileExtension(file: File) {
        var extension = this.getFileExtension(file.name);
        if (isDefined(extension)) {
            return extension;
        } else {
            return false;
        }
    }

    getFileSilentUploadLimit() {
        return FileSilentUploadLimit;
    }

    getFileUploadLimit(fileName: string) {
        const currentCustomer = this.customerDataService.customerData;
        if (!this.customerDataService.customerData) {
            return 0;
        }

        const extension = this.getFileExtension(fileName);

        if (currentCustomer.LargeFiles.indexOf(extension) !== -1) return currentCustomer.LargeFilesUploadLimit;
        else if (currentCustomer.MiddleFiles.indexOf(extension) !== -1) return currentCustomer.MiddleFilesUploadLimit;

        return currentCustomer.FileUploadLimit;
    }
}
